export default __webpack_public_path__ + "locales/bg/InviteDialog.json?hash=99c2245d1d23bbc30a1c4881df4e4135";